export interface BlacklistMemberDetailsDto
{
    getBPartyName(): string;
    getBPartyMsisdn(): string;
}

export class BlacklistMemberDetailsDtoImpl implements BlacklistMemberDetailsDto
{
    private bPartyName: string;
    private bPartyMsisdn: string;

    setBPartyName(bPartyName: string)
    {
        this.bPartyName = bPartyName;
    }
    getBPartyName(): string
    {
       return this.bPartyName;
    }    

    setBPartyMsisdn(bPartyMsisdn: string)
    {
        this.bPartyMsisdn = bPartyMsisdn;
    }
    getBPartyMsisdn(): string 
    {
        return this.bPartyMsisdn;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/dto/addtoblacklist/blacklistmemberdetailsdto.ts